import { motion, useScroll, useTransform } from "framer-motion";
import { useRef } from "react";
import { fadeUp, viewport } from "@/lib/motion";
import { IMAGES } from "@/data";
import { useLang } from "@/context/LanguageContext";

export const WhyTurkiye = () => {
  const { t } = useLang();
  const w = t.why;
  const ref = useRef(null);
  const { scrollYProgress } = useScroll({ target: ref, offset: ["start end", "end start"] });
  const y = useTransform(scrollYProgress, [0, 1], ["-8%", "8%"]);

  return (
    <section id="why" ref={ref} className="relative overflow-hidden grain scroll-mt-20">
      <div className="absolute inset-0">
        <motion.img src={IMAGES.istanbul} alt="Istanbul skyline at sunset" style={{ y }} className="h-[116%] w-full object-cover" />
        <div className="absolute inset-0 bg-[#0D2A27]/85" />
      </div>

      <div className="relative max-w-7xl mx-auto px-6 md:px-12 py-24 md:py-32">
        <motion.p variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="overline text-[#C4A484] mb-6">{w.overline}</motion.p>
        <motion.h2 variants={fadeUp} custom={1} initial="hidden" whileInView="show" viewport={viewport} className="font-serif text-4xl md:text-5xl lg:text-6xl leading-[0.98] tracking-tight text-[#F7F6F2] max-w-3xl">{w.heading}</motion.h2>

        <div className="mt-16 grid grid-cols-2 lg:grid-cols-4 gap-x-6 gap-y-12">
          {w.items.map((item, i) => (
            <motion.div key={i} variants={fadeUp} custom={i} initial="hidden" whileInView="show" viewport={viewport} className="border-t border-[#F7F6F2]/25 pt-5">
              <p className="font-serif text-4xl md:text-5xl text-[#F7F6F2] leading-none">{item.stat}</p>
              <p className="mt-3 text-sm text-[#F7F6F2]/70 leading-relaxed">{item.label}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};
